import React from "react";
import {AppBar, Box, Button, Menu, MenuItem, Paper, Toolbar, Typography} from "@mui/material";
import {KeyboardArrowDown} from "@mui/icons-material";
import {Link} from "gatsby-theme-material-ui";
import logo from "../images/logo.png";
import "../css/main.css";
import {Helmet} from "react-helmet";

const dropdownStyle = {
    marginRight: '0'
};

const linkStyle = {
    textDecoration: 'none',
    color: '#333',
    marginRight: '1rem'
};

const footerLinkStyle = {
    textDecoration: 'none',
    color: '#333',
    marginRight: '2rem'
};

export default function Layout({title, children}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Helmet titleTemplate="%s | juryboxapp.com" defer={false}>
                <html lang="en" />
                <title>{title}</title>
                <meta name="description" content="Jury selection software for trial attorneys; voir dire simplified!"/>
            </Helmet>
            <AppBar position="fixed" style={{backgroundColor: "white"}}>
                <Toolbar style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: "center", padding: "1em 0.5em"}}>
                    <Link to={"/"} style={{lineHeight: 0}}><img src={logo} id={"header-logo"}
                                                                alt={"Jurybox logo"}/></Link>
                    <div className={'nav-bar-menu'}>
                        <Button style={dropdownStyle}
                                variant={"outlined"}
                                color={"secondary"}
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDown/>}>Info</Button>
                        <Menu open={open}
                              anchorEl={anchorEl}
                              onClose={handleClose}>
                            <MenuItem>
                                <Link to={"/info/jurybox-faqs"} style={linkStyle}>Jurybox FAQs</Link>
                            </MenuItem>
                            <MenuItem>
                                <Link to={"/info/how-to-guide"} style={linkStyle}>How to Guide</Link>
                            </MenuItem>
                            <MenuItem>
                                <Link to={"/info/about-us"} style={linkStyle}>About Us</Link>
                            </MenuItem>
                            <MenuItem>
                                <Link to={"/info/contact"} style={linkStyle}>Contact</Link>
                            </MenuItem>
                        </Menu>
                        <Button href={"https://app.juryboxapp.com"} color="primary" variant="contained">Sign in</Button>
                    </div>
                </Toolbar>
            </AppBar>
            <div id="main-content">
                {children}
                <footer>
                    <Paper sx={{padding: "1rem"}} square variant={"outlined"}>
                        <Typography variant={"overline"}>&copy; {(new Date()).getFullYear()} Jurybox Technologies,
                            LLC - All Rights Reserved</Typography>

                        <Box display={"flex"} flexDirection={"row"} marginTop={2}>
                            <Box>
                                <Link to={"/privacy-policy"} style={footerLinkStyle}>Privacy Policy</Link>
                            </Box>
                            <Box>
                                <Link to={"/license-agreement"} style={footerLinkStyle}>Terms of Service</Link>
                            </Box>
                        </Box>
                    </Paper>
                </footer>
            </div>
        </div>
    )
}
